import * as React from "react"

export const PluginsIcon = ({
  width = 40,
  height = 40,
  ...rest
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...rest}
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="8" fill="#F9F2FF" />
    <path
      d="M24.9245 17.6965L22.8032 15.5752L19.2677 19.1107L21.389 21.232L24.9245 17.6965Z"
      stroke="#7026B9"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.6875 10.5322L30.5312 9.84392L29.8429 11.6876L30.5312 13.5313L28.6875 12.843L26.8438 13.5313L27.5321 11.6876L26.8438 9.84392L28.6875 10.5322Z"
      fill="#7026B9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7147 10.8281L20.2426 12.2423L18.8284 11.7144L17.4142 12.2423L17.9422 10.8281L17.4142 9.41391L18.8284 9.94188L20.2426 9.41391L19.7147 10.8281Z"
      fill="#7026B9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.7147 24.8281L28.2426 26.2423L26.8284 25.7144L25.4142 26.2423L25.9422 24.8281L25.4142 23.4139L26.8284 23.9419L28.2426 23.4139L27.7147 24.8281Z"
      fill="#7026B9"
    />
    <path
      d="M19.2676 19.1108L21.3889 21.2322L13.2572 29.3639C12.6714 29.9497 11.7216 29.9497 11.1359 29.3639V29.3639C10.5501 28.7781 10.5501 27.8284 11.1359 27.2426L19.2676 19.1108Z"
      stroke="#7026B9"
      strokeWidth="1.5"
    />
  </svg>
)
